import React from 'react';
import EmployeesTableContainer from '../containers/EmployeesTableContainer';

export default function EmployeesLandingPres(props) {
  return <EmployeesTableContainer {...props} />;
}
